var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStackedBarChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H2V14H4V4ZM9 7H7V14H9V7ZM14 2V14H12V2L14 2ZM12 1C11.4477 1 11 1.44772 11 2V14C11 14.5523 11.4477 15 12 15H14C14.5523 15 15 14.5523 15 14V2C15 1.44772 14.5523 1 14 1H12ZM6 7C6 6.44772 6.44772 6 7 6H9C9.55228 6 10 6.44772 10 7V14C10 14.5523 9.55228 15 9 15H7C6.44772 15 6 14.5523 6 14V7ZM1 4C1 3.44772 1.44772 3 2 3H4C4.55228 3 5 3.44772 5 4V14C5 14.5523 4.55228 15 4 15H2C1.44772 15 1 14.5523 1 14V4Z",
    fill: "#4559A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5H14.5V9H12V6H14V8.5H12.5V6.5H13.5V7.5V8M7 11V14H9V11H8H7ZM8.5 10.5V13.5H7.5V10.5H8.5Z",
    stroke: "#4559A7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10V13.5M12 9.5H14V14H12V9.5Z",
    stroke: "#4559A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10V13.5M2 9.5H4V14H2V9.5Z",
    stroke: "#4559A7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9H4V8H2",
    stroke: "#4559A7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedBarChart);
export default __webpack_public_path__ + "static/media/stacked-bar-chart.261e6a0727e8ba5b6b8c58b35d1394a6.svg";
export { ForwardRef as ReactComponent };